import { debounce } from 'lodash'
import { useCallback } from 'react'

/**
 * Use in React Functional Components to make debounce work (otherwise, new callback function instance would be created on each render.)
 *
 * Attention: The callback must be a pure function!
 *
 * @param callback
 * @param delay
 */
export function useDebouncedCallback<T extends (...args: any) => any>(
  callback: T,
  delay: number,
  dep?: any[],
) {
  const d = callback

  // TODO: CQI-2 fix this violation of react-hooks/exhaustive-deps
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callbackfunc = useCallback(debounce(d, delay), dep ?? [])

  return [callbackfunc]
}
